/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import { useState } from 'react';
import * as PropTypes from 'prop-types';
interface SymbolProps {
  img?: string;
  initials?: string;
}

const Symbol: React.FC<SymbolProps> = ({ img, initials }) => {
  // Thumbnails are generated on the fly and can fail (e.g. no still available
  // for a video), so fall back to the initials instead of a broken image.
  const [brokenImg, setBrokenImg] = useState<string | undefined>();
  const usableImg = img && img !== brokenImg ? img : undefined;

  if (!usableImg && !initials)
    return (
      <div className="symbol symbol-40px user-select-none">
        <div className="symbol-label fs-2 fw-semibold text-success">?</div>
      </div>
    );
  if (usableImg)
    return (
      <div className="symbol symbol-40px user-select-none">
        {/* The theme sizes the img to the symbol box, which stretches anything
            that is not square — cover crops instead of distorting. */}
        <img
          src={usableImg}
          alt=""
          style={{ objectFit: 'cover' }}
          onError={() => setBrokenImg(usableImg)}
        />
      </div>
    );
  if (initials)
    return (
      <div className="symbol symbol-40px user-select-none">
        <div className="symbol-label fs-2 fw-semibold text-success">
          {initials}
        </div>
      </div>
    );
  return null;
};

export default Symbol;
Symbol.propTypes = {
  img: PropTypes.string,
  initials: PropTypes.string
};
